import { render, staticRenderFns } from "./panjar-ikhtisar-table.vue?vue&type=template&id=30215238&scoped=true&"
import script from "./panjar-ikhtisar-table.vue?vue&type=script&lang=js&"
export * from "./panjar-ikhtisar-table.vue?vue&type=script&lang=js&"
import style0 from "./panjar-ikhtisar-table.vue?vue&type=style&index=0&id=30215238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30215238",
  null
  
)

export default component.exports